// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-07552153]{width:100%}table tr[data-v-07552153]{border-bottom-width:1px;border-top-width:1px;--tw-border-opacity:1;border-color:#f2f2f2;border-color:rgba(242,242,242,var(--tw-border-opacity))}table tr td[data-v-07552153]{line-height:1;padding-bottom:.75rem;padding-top:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
